import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Agent } from '../models/agent.model';
import { AgentType } from '../../../agent-types/data-access/models/agent-type.model';

@Injectable({ providedIn: 'root' })
export class AgentesService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/analysis-documents`;
  private promptApiUrl = `${environment.apiUrl}/api/prompt`;

  getPromptsOptions(): Observable<any[]> {
    return this.http.get<any>(`${environment.apiUrl}/api/prompt/options`).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[AgentesService] GET types request failed', error);
        return throwError(() => error);
      }
    ));
  }

  getAgentes(type: number): Observable<Agent[]> {
    return this.http.get<any>(`${this.promptApiUrl}/type/${type}`).pipe(
      map(response => [response.data]),
      catchError((error) => {
        console.error('[AgentesService] GET request failed', error);
        return throwError(() => error);
      })
    );
  }

  getAgentByTypeVersion(type: number, version: string): Observable<Agent[]> {
    return this.http.get<any>(`${this.promptApiUrl}/type/${type}/version/${version}`).pipe(
      map(response => [response.data]),
      catchError((error) => {
        console.error('[AgentesService] GET request failed', error);
        return throwError(() => error);
      })
    );
  }

  createNewVersion(id: number, employeeId: number, content: string, promptManager: string | null, minScore: string): Observable<Agent> {
    return this.http.post<any>(`${environment.apiUrl}/api/new-version/prompt/${id}`, {
      min_score: minScore,
      prompt_manager: promptManager,
      content: content
    }).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[AgentesService] POST new-version request failed', error);
        return throwError(() => error);
      })
    );
  }

  updateAgent(id: number, content: string, promptManager: string, minScore: string): Observable<Agent> {
    return this.http.put<Agent>(`${this.promptApiUrl}/${id}`, {
      content: content,
      prompt_manager: promptManager,
      min_score: minScore
    }).pipe(
      catchError((error) => {
        console.error('[AgentesService] PUT request failed', error);
        return throwError(() => error);
      })
    );
  }
}
